import { useTheme } from "../../../hooks/ThemeContext"
import "./CategoryButtonComponentStyles.css"

type Props = {
    buttonText: string,
    isSelected?: boolean,
    onClick: any,
    reference?: any,
}

const CategoryButtonComponent = (props: Props) => {

    const { theme } = useTheme();

    return (
        <div
            ref={props.reference}
            className={`category-button ${props.isSelected ? "selected" : "not-selected"}`}
            onClick={props.onClick}
            role="tab"
            tabIndex={0}
            aria-selected={props.isSelected}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") { e.preventDefault(); props.onClick?.(); }
            }}
            style={{
                display: "flex",
                height: "100%",
                marginLeft: "20px",
                flex: "1",
                paddingLeft: "10px",
                paddingRight: "10px",
                whiteSpace: "nowrap",
                backgroundColor: "",
                margin: "0",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxSizing: "border-box",
                fontFamily: 'var(--app-display-font, "Bricolage Grotesque", sans-serif)',
                fontSize: "17px",
                letterSpacing: "-0.01em",
                ["--cat-indicator" as any]: theme.categoryIndicatorColor,
            }}
        >
            <span data-text={props.buttonText}>{props.buttonText}</span>
        </div>
    )
}

export default CategoryButtonComponent;